import {
  ENV,
  authFetch,
  parseResponse,
  SUCCESSARRAY,
} from "../utils";

export class Role {
  async createRole(data) {
    const roleData = {
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      menuPermissions: Array.isArray(data.menuPermissions)
        ? data.menuPermissions
        : [],
      actionPermissions: Array.isArray(data.actionPermissions)
        ? data.actionPermissions
        : [],
    };

    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.ROLE.ROLE}`;

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(roleData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getRoles(page = 1, limit = 10, filters = {}) {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...filters,
    });

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.ROLE.ROLES}` +
      `?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getRole(roleId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.ROLE.ROLE}/` +
      roleId;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async updateRole(roleId, data) {
    const roleData = {
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      menuPermissions: Array.isArray(data.menuPermissions)
        ? data.menuPermissions
        : [],
      actionPermissions: Array.isArray(data.actionPermissions)
        ? data.actionPermissions
        : [],
    };

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.ROLE.ROLE}/` +
      roleId;

    const params = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(roleData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async deleteRole(roleId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.ROLE.ROLE}/` +
      roleId;

    const params = {
      method: "DELETE",
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}
